import { Box, Chip, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { ParsedClinicNfbCapacity } from "./clinicNfbCapacityParser";

type ClinicNfbCapacityPresenterProps = {
    clinicName: string;
    nfbCapacity: ParsedClinicNfbCapacity;
};

const roomsCellStyle = (rooms: number) => {
    const cellStyle = { textAlign: "center", color: rooms === 0 ? "text.disabled" : "text.primary", px: 1 };
    return cellStyle;
};

export const ClinicNfbCapacityPresenter = ({ clinicName, nfbCapacity }: ClinicNfbCapacityPresenterProps) => {
    const periodRows = [
        { periodLabel: "Manhã", getRooms: (dayIndex: number) => nfbCapacity.weekdayCapacities[dayIndex].morningRooms },
        { periodLabel: "Tarde", getRooms: (dayIndex: number) => nfbCapacity.weekdayCapacities[dayIndex].afternoonRooms },
    ];

    return (
        <Stack direction="row" spacing={3} alignItems="center" flexWrap="wrap">
            <Box>
                <Typography variant="subtitle2" color="primary">
                    Capacidade NFB · {clinicName}
                </Typography>
                <Table size="small" padding="none" sx={{ width: "auto" }}>
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            {nfbCapacity.weekdayCapacities.map((weekdayCapacity) => (
                                <TableCell key={weekdayCapacity.weekdayLabel} sx={{ textAlign: "center", px: 1, fontWeight: 600 }}>
                                    {weekdayCapacity.weekdayLabel}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {periodRows.map((periodRow) => (
                            <TableRow key={periodRow.periodLabel}>
                                <TableCell sx={{ pr: 1, fontWeight: 600 }}>{periodRow.periodLabel}</TableCell>
                                {nfbCapacity.weekdayCapacities.map((weekdayCapacity, dayIndex) => (
                                    <TableCell key={weekdayCapacity.weekdayLabel} sx={roomsCellStyle(periodRow.getRooms(dayIndex))}>
                                        {periodRow.getRooms(dayIndex)}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
            <Stack direction="row" spacing={1} flexWrap="wrap">
                {nfbCapacity.blockedWindows.map((blockedWindow) => (
                    <Chip
                        key={`${blockedWindow.weekdayLabel}-${blockedWindow.timeRangeLabel}`}
                        size="small"
                        color="warning"
                        variant="outlined"
                        label={`Bloqueado · ${blockedWindow.weekdayLabel} ${blockedWindow.timeRangeLabel}`}
                    />
                ))}
            </Stack>
        </Stack>
    );
};
